import React from 'react'

const IconShieldLinear = ({
  className,
  strokeWidth = '1'
}: {
  className: string
  strokeWidth: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75001 6.82206L14.5 3.75178L25.25 6.82206C25.2442 14.0818 22.5469 18.6724 19.8726 21.4555C17.2753 24.1583 14.6728 25.1816 14.5 25.2479C14.3271 25.1816 11.7247 24.1583 9.12745 21.4555C6.45309 18.6724 3.75578 14.0818 3.75001 6.82206Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <path
        d="M9.85938 14.5L13.2344 17.875L19.9844 9.4375"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default IconShieldLinear
